import Local from '@/app/module/local'
import Response from '@/app/model/api/response/responseValue'

class GetImageApi {
  public getImageData (bodyData: any) {
    const path = '/v1/field/image'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ planting_id: bodyData.planting_id, date: bodyData.date })

    if (bodyData.type !== '') {
      params.append('type', bodyData.type)
    }

    url.search = params.toString()

    return fetch(url.href, {
      method: 'GET',
      headers: {
        'X-Auth-Token': Local.getAuthToken()!
      }
    })
      .then(response => {
        if (response.status === 200) {
          return response.blob()
        } else {
          throw Error(String(response.status))
        }
      })
      .then(data => {
        const outside: any = URL.createObjectURL(data)
        return outside
      })
      .catch(e => {
        return new Response(false, e)
      })
  }
}

export default new GetImageApi()
